/**
 * @generated SignedSource<<5d80b78189161b26b6548743419f7e53>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type GenerateEstimatedPayoutTotalInput = {
  clientMutationId?: string | null | undefined;
  dateFrom: string;
  dateTo: string;
};
export type GenerateEstimatedPayoutTotalMutation$variables = {
  input: GenerateEstimatedPayoutTotalInput;
};
export type GenerateEstimatedPayoutTotalMutation$data = {
  readonly generateEstimatedPayoutTotal: {
    readonly errors: any | null | undefined;
    readonly profileGroup: {
      readonly estimatedTotalAmountUnpaid: number | null | undefined;
      readonly generatedEstimatedPayoutTotalFromDate: string | null | undefined;
      readonly generatedEstimatedPayoutTotalToDate: string | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type GenerateEstimatedPayoutTotalMutation = {
  response: GenerateEstimatedPayoutTotalMutation$data;
  variables: GenerateEstimatedPayoutTotalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateEstimatedPayoutTotalPayload",
    "kind": "LinkedField",
    "name": "generateEstimatedPayoutTotal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileGroupNode",
        "kind": "LinkedField",
        "name": "profileGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimatedTotalAmountUnpaid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "generatedEstimatedPayoutTotalFromDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "generatedEstimatedPayoutTotalToDate",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GenerateEstimatedPayoutTotalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GenerateEstimatedPayoutTotalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fd1b2b938133f44aeb1159757fa58e4d",
    "id": null,
    "metadata": {},
    "name": "GenerateEstimatedPayoutTotalMutation",
    "operationKind": "mutation",
    "text": "mutation GenerateEstimatedPayoutTotalMutation(\n  $input: GenerateEstimatedPayoutTotalInput!\n) {\n  generateEstimatedPayoutTotal(input: $input) {\n    success\n    errors\n    profileGroup {\n      id\n      estimatedTotalAmountUnpaid\n      generatedEstimatedPayoutTotalFromDate\n      generatedEstimatedPayoutTotalToDate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ea9445b6492f1f67ed9e1f4319823cb";

export default node;
